import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Col, Divider, Empty, Row, Select } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { UpsellModal } from "@devowl-wp/react-cookie-banner-admin";
import { StatsButtonClickedPieChart } from "./buttonClickedPie.js";
import { StatsCustomBypassPieChart } from "./customBypassPie.js";
import { StatsMainBarChart } from "./mainBar.js";
import { useAvailableDateRangesForFilter } from "../../../../hooks/useAvailableDateRangesForFilter.js";
import { useStores } from "../../../../store/stores.js";
import { __ } from "../../../../utils/i18n.js";
import { DateRangePicker } from "../../../dateRangePicker.js";
const StatsGrid = observer(()=>{
    const { optionStore: { others: { isPro, assetsUrl }, contexts }, statsStore } = useStores();
    const { filters: { dates, context } } = statsStore;
    const contextKeys = Object.keys(contexts);
    const [statsLiteInContainerRef, setStatsLiteInContainerRef] = useState();
    // Provide predefined ranges to the user
    const availableRanges = useAvailableDateRangesForFilter();
    return isPro ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    textAlign: "right"
                },
                children: [
                    contextKeys.length > 1 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: /*#__PURE__*/ _jsx(Select, {
                                    style: {
                                        width: 200,
                                        textAlign: "left"
                                    },
                                    value: context,
                                    onSelect: (e)=>statsStore.applyContext(e),
                                    children: contextKeys.map((context)=>/*#__PURE__*/ _jsx(Select.Option, {
                                            value: context,
                                            children: contexts[context]
                                        }, context))
                                })
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                type: "vertical"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("label", {
                        children: [
                            __("Period"),
                            ":",
                            " ",
                            /*#__PURE__*/ _jsx(DateRangePicker, {
                                value: /* Ant design relies on moment 2.27 and typings are currently incompatible with other moment typings */ dates,
                                ranges: availableRanges,
                                onChange: (dates)=>statsStore.applyDates(dates)
                            })
                        ]
                    })
                ]
            }),
            dates?.length === 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsxs(Col, {
                                md: 12,
                                sm: 24,
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        children: __("Consents by clicked button")
                                    }),
                                    /*#__PURE__*/ _jsx(StatsButtonClickedPieChart, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Col, {
                                md: 12,
                                sm: 24,
                                children: [
                                    /*#__PURE__*/ _jsx(Divider, {
                                        children: __("Cookie banner bypass")
                                    }),
                                    /*#__PURE__*/ _jsx(StatsCustomBypassPieChart, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Row, {
                        children: /*#__PURE__*/ _jsxs(Col, {
                            md: 20,
                            sm: 24,
                            style: {
                                margin: "auto",
                                paddingTop: 20,
                                marginTop: 30
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Divider, {
                                    children: __("Consents by group")
                                }),
                                /*#__PURE__*/ _jsx(StatsMainBarChart, {})
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsx(Empty, {
                description: __("Please provide a date range!")
            })
        ]
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(UpsellModal, {
                title: __("Want to see detailed statistics about the consents of your visitors?"),
                inContainer: true,
                inContainerElement: statsLiteInContainerRef,
                testDrive: true,
                feature: "stats",
                description: __("You can get several statistics about how your users use the cookie banner. This helps you to calculate the total number of users who do not want to be tracked, for example, by extrapolating data from Google Analytics.")
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: setStatsLiteInContainerRef,
                className: "rcb-antd-modal-mount",
                style: {
                    height: 800,
                    backgroundImage: `url('${assetsUrl}statistics-blured.png')`
                }
            })
        ]
    });
});
export { StatsGrid };
